import React from "react";
import { GitHub, Mail, Linkedin } from "react-feather";
import "../assets/css/about.css";
import Akshit from "../assets/img/akshit.png";

const About = () => {
  return (
    <div className="content">
      <div className="back">
        <span className="head">Covid-19 INDIA</span>
        <img alt="about us" id="pic" src={Akshit} />
        <div className="links">
          <a
            href="https://github.com/akshitsuri"
            className="icon"
            target="_blank"
            rel="noopener noreferrer"
          >
            <GitHub />
          </a>

          <a
            href="https://www.linkedin.com/in/akshit-suri-54a5611a9/"
            target="_blank"
            rel="noopener noreferrer"
            className="icon"
          >
            <Linkedin />
          </a>

          <a
            href="mailto:a.akshitsuri@gmail.com"
            className="icon"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Mail />
          </a>
        </div>

        <span id="name">Akshit Suri</span>
      </div>
    </div>
  );
};

export default About;
